import React, { Fragment, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Button, ButtonGroup, Card, CardBody, Col, Row } from "reactstrap";
import GraphCard from "../components/cards/GraphCard";
import LineCore from "../components/charts/LineCore";
import MainFilter from "../components/filters/MainFilter";
import moment from "moment";
import { footfallRequest, footfallGraphRequest } from "../helpers/requests";
import { setCategoryFilter } from "../redux/actions/categoryAction";
import { setFootfallFilter, setFootfallGraphType, setGrapghData } from "../redux/actions/footfallActions";
import { BarChart2, TrendingUp } from "react-feather";

const Visitors = () => {
  const user = useSelector((state) => state.auth);
  const type = useSelector((state) => state.footfallReducer.type);
  let enabledFeatures = user?.user?.client_id[0]?.feature;
  const graphRealData = useSelector((state) => state.footfallReducer.graphs);
  const [labels, setLabels] = useState([])
  const footFall = enabledFeatures?.footfall;
  const [title, setTitle] = useState();
  const [filter, setFilter] = useState();

  const dispatch = useDispatch();
  const all_data = useSelector((state) => state?.footfallReducer?.all_data);
  const grapghRawData = useSelector((state) => state.footfallReducer.grapGhRawData )

  const updateFilter = (e) => {
    setFilter(e);
    dispatch(setFootfallFilter({ start: e.start, end: e.end }));
    e["dispatch"] = dispatch;
    let _filter = {
      _startDate: e.start,
      _endDate: e.end,
    }
    dispatch(setCategoryFilter(_filter));
    footfallRequest(e);
    footfallGraphRequest(e);
    // getVisitor({ fid: e.fid, sid: e.sid, start: e.start, end: e.end });
  };
  const [showGraph, setShowGraph] = useState(true);
  const getLabels = (startDate, endDate) => {
    var labels = [];
    var start = moment(startDate);
    var end = moment(endDate);
    if (end.diff(start, "day") < 1) {
      while (end.diff(start, "hour") > 0) {
        labels.push(start.format("hh:mm a"));
        start = start.add(1, "hour");
      }
    } else {
      end = end.startOf("day");
      while (end.diff(start, "day") >=0) {
        labels.push(start.format("MMM D"));
        start = start.add(1, "day");
      }
    }
    console.log('Labels',labels);
    return labels;
  
  };

  const setType = (_type) => {
    dispatch(setFootfallGraphType(_type));
  }


  useEffect(() => {
    if(filter) {
    let labels = getLabels(filter.start, filter.end)
    setLabels(labels)
  }
  }, [filter])

  useEffect(() => {
    if(footFall){
    }   
    setShowGraph(false);
    setTimeout(() => {
      setShowGraph(true)
    }, 10)
   
  }, [type]);

  useEffect(() => {
    if(footFall){
      setTitle(footFall[0].key);
    }
  }, [footFall])
  

  useEffect(() => {
    setShowGraph(false);
    setTimeout(() => {
      setShowGraph(true)
    }, 10)
  }, [labels]);

  useEffect(() => {
    if (title) {
      setShowGraph(false);
      setTimeout(() => {
        setShowGraph(true)
      }, 10)
    }
  }, [title]);

  useEffect(() => {
    if(grapghRawData) {
      if(enabledFeatures){
        dispatch(setGrapghData({footfall : enabledFeatures.footfall, grapghRawData : grapghRawData, startDate :filter?.start, endDate : filter?.end }))
      }
    }
  }, [grapghRawData,enabledFeatures,filter]);



  const summaryMenu = [
      ["line", <TrendingUp size={16} />],
      ["bar", <BarChart2 size={16} />],
  ];



  return (
    <Fragment>
      <MainFilter pageTitle="Traffic" updateFilter={(e) => updateFilter(e)} type='gold'></MainFilter>
      <Row className="mb-4">
        {footFall && 
          footFall?.map((item, key) => {
            return (
              <Col md={2} className={"mb-4 card-col " + (title == item.key ? "active" : '')} onClick={() => setTitle(item.key)} style={{ cursor: "pointer" }}>
                <GraphCard parent = {{label : item.label, key : item.key}}  childrenLabel ={item?.children} allData = {all_data} />
              </Col>
            )
          })
        }
        {
          !footFall ? <><span className='className="d-block small opacity-50"'><i>You dont have any feature please contact admin</i></span></> : !all_data? <><span className='className="d-block small opacity-50"'><i>You dont have any data in default selected Filter</i></span></> :''
        }
      </Row>
      <Row>
        <Col>
          {graphRealData &&  title && graphRealData[title] && showGraph && labels &&
            <Card>
              <CardBody>
                  <Row>
                    <Col className="text-end">
                      <ButtonGroup>
                        {
                            summaryMenu.map((val, index) => {
                                return (
                                    <Button
                                        href={"#toggle-tab-" + val[0]}
                                        color={type == val[0] ? "outline-primary" : "outline-light"}
                                        className='section-tab'
                                        size='sm'
                                        onClick={()=> setType(val[0])}
                                        active={type == val[0] ? true : null}
                                        key={"compare-tab-" + index}
                                    >
                                        {val[1]}
                                    </Button>
                                );
                            })
                        }
                      </ButtonGroup>
                      {/* <Button color={type == 'line' ? 'primary' : 'outline-primary'} onClick={()=> setType("line")} className="mx-2 btn-sm">Line</Button> 
                      <Button color={type == 'bar' ? 'primary' : 'outline-primary' } onClick={()=> setType("bar")} className="btn-sm">Bar</Button>  */}
                    </Col>
                  </Row>
                 <LineCore legends={''} labels={labels} data={graphRealData[title]?.data}/>  
              </CardBody>
            </Card>
          }
          {
            !footFall &&
            <span className='className="d-block small opacity-50"'><i>You dont have any enabled features to plot on graph </i></span>
          }
        </Col>
      </Row>
    </Fragment>
  );
};

export default Visitors;
